import { ILocaleSiteLinks } from '@Hotels-at-Home/hah-fe-core/dist/types/header';
import { IImage } from '@Hotels-at-Home/hah-fe-core/dist/types/image';
import { catalogId } from './siteConfig';

export const siteLinks: ILocaleSiteLinks = {
  en: [
    {
      id: 1,
      url: `https://europe.westinstore.com/en?___store=hbeu_en&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=HBEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Westin Store',
    },
    {
      id: 2,
      url: `https://europe.sheratonstore.com/en?___store=sheu_en&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=SHEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Sheraton Store',
    },
    {
      id: 3,
      url: `https://europe.collectrenaissance.com/en?___store=rhreu_en&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=RHREU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Collect Renaissance',
    },
    {
      id: 4,
      url: `https://europe.shopcourtyard.com/en?___store=cymeu_en&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=CYMEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop Courtyard',
    },
  ],
  fr: [
    {
      id: 1,
      url: `https://europe.westinstore.com/fr?___store=hbeu_fr&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=HBEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Westin Store',
    },
    {
      id: 2,
      url: `https://europe.sheratonstore.com/fr?___store=sheu_fr&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=SHEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Sheraton Store',
    },
    {
      id: 3,
      url: `https://europe.collectrenaissance.com/fr?___store=rhreu_fr&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=RHREU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Collect Renaissance',
    },
    {
      id: 4,
      url: `https://europe.shopcourtyard.com/fr?___store=cymeu_fr&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=CYMEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop Courtyard',
    },
  ],
  de: [
    {
      id: 1,
      url: `https://europe.westinstore.com/de?___store=hbeu_de&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=HBEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Westin Store',
    },
    {
      id: 2,
      url: `https://europe.sheratonstore.com/de?___store=sheu_de&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=SHEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Sheraton Store',
    },
    {
      id: 3,
      url: `https://europe.collectrenaissance.com/de?___store=rhreu_de&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=RHREU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Collect Renaissance',
    },
    {
      id: 4,
      url: `https://europe.shopcourtyard.com/de?___store=cymeu_de&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=CYMEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop Courtyard',
    },
  ],
  es: [
    {
      id: 1,
      url: `https://europe.westinstore.com/es?___store=hbeu_es&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=HBEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Westin Store',
    },
    {
      id: 2,
      url: `https://europe.sheratonstore.com/es?___store=sheu_es&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=SHEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Sheraton Store',
    },
    {
      id: 3,
      url: `https://europe.collectrenaissance.com/es?___store=rhreu_es&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=RHREU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Collect Renaissance',
    },
    {
      id: 4,
      url: `https://europe.shopcourtyard.com/es?___store=cymeu_es&utm_source=HAH&utm_medium=site-${catalogId}&utm_content=CYMEU&utm_term=${catalogId}&utm_campaign=PanBrand-Header-Links`,
      title: 'Shop Courtyard',
    },
  ],
};

export const bonvoyLogo: IImage = {
  src: '/images/misc/bonvoy-logo.svg',
  alt: 'Shop logo',
  height: '47.25',
  width: '100',
};
